import { Injectable } from '@angular/core';
import { filter, Subject, Subscription } from 'rxjs';

export interface EventWithContent<T = unknown> {
  name: string;
  content?: T;
}

@Injectable({ providedIn: 'root' })
export class EventManager {
  private eventBus = new Subject<EventWithContent>();

  broadcast(event: EventWithContent): void {
    this.eventBus.next(event);
  }

  subscribe(eventName: string, callback: (event: EventWithContent) => void): Subscription {
    return this.eventBus.pipe(filter(event => event.name === eventName)).subscribe(callback);
  }

  destroy(subscriber?: Subscription): void {
    if (subscriber) {
      subscriber.unsubscribe();
    }
  }
}
